// IMPORT PACKAGE REFERENCES
import React, { Component } from 'react';

import { Auth } from '@aws-amplify/auth';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import Swal from 'sweetalert2';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { federatedLogin } from '../state/actions/AuthActions';
// IMPORT PROJECT REFERENCES
import { signUp } from '../state/actions/SignUpActions';

// COMPONENT

class SignupComponent extends Component {
    constructor(props) {
        super(props);

        // reset login status
        //this.props.logout();

        this.state = {
            firstName: '',
            lastName: '',
            companyName: '',
            username: '',
            password: '',
            submitted: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAuthStateChange = this.handleAuthStateChange.bind(this);
        this.handleSignUpErrorMessage = this.handleSignUpErrorMessage.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { firstName, lastName, companyName, username, password } = this.state;

        if (firstName && lastName && companyName && username && password) {
            this.props.signUp(
                firstName,
                lastName,
                companyName,
                username,
                password,
                this.handleSignUpErrorMessage
            );
        }
    }

    handleAuthStateChange(state) {
        //console.log('handleAuthStateChange', state);
        console.log('user', this.props.user);

        if (state === 'signedIn') {
            Auth.currentAuthenticatedUser().then(user => {
                //console.log('user', user);
                this.props.federatedLogin(user, this.handleFederatedLoginSuccess);
            });
        }
    }

    handleFederatedLoginSuccess() {
        console.log('handleFederatedLoginSuccess');
    }

    handleSignUpErrorMessage(errorMessage) {
        Swal({
            title: 'Oops...',
            text: errorMessage,
            type: 'error',
        });
    }

    render() {
        const loginFormStyle = {
            padding: '25px',
        };

        const { signingUp, user } = this.props;
        const { firstName, lastName, companyName, username, password, submitted } = this.state;

        console.log('user signup', user);

        if (user && !signingUp) {
            const link = '/signup-confirm?username=' + user.user.username;
            return <Redirect to={link} />;
        } else {
            return (
                <div className="row h-100 align-items-center justify-content-center">
                    <div style={loginFormStyle} className="card col-6 my-auto">
                        <div className="col-12">
                            <h2 className="text-center">Start Your 30-day Free Trial</h2>
                            <h4 className="text-center">
                                Fully functional. No credit card required.
                            </h4>
                            <form name="form" onSubmit={this.handleSubmit}>
                                <div className="form-group text-center or-break">
                                    <span>or with your email below</span>
                                </div>
                                <div
                                    className={
                                        'form-group' + (submitted && !firstName ? ' has-error' : '')
                                    }
                                >
                                    <label htmlFor="firstName">First Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="firstName"
                                        value={firstName}
                                        onChange={this.handleChange}
                                    />
                                    {submitted && !firstName && (
                                        <div className="help-block">First Name is required</div>
                                    )}
                                </div>
                                <div
                                    className={
                                        'form-group' + (submitted && !lastName ? ' has-error' : '')
                                    }
                                >
                                    <label htmlFor="lastName">Last Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="lastName"
                                        value={lastName}
                                        onChange={this.handleChange}
                                    />
                                    {submitted && !lastName && (
                                        <div className="help-block">Last Name is required</div>
                                    )}
                                </div>
                                <div
                                    className={
                                        'form-group' +
                                        (submitted && !companyName ? ' has-error' : '')
                                    }
                                >
                                    <label htmlFor="companyName">Company Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="companyName"
                                        value={companyName}
                                        onChange={this.handleChange}
                                    />
                                    {submitted && !companyName && (
                                        <div className="help-block">Company Name is required</div>
                                    )}
                                </div>
                                <div
                                    className={
                                        'form-group' + (submitted && !username ? ' has-error' : '')
                                    }
                                >
                                    <label htmlFor="username">Work Email</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="username"
                                        value={username}
                                        onChange={this.handleChange}
                                    />
                                    {submitted && !username && (
                                        <div className="help-block">Work Email is required</div>
                                    )}
                                </div>
                                <div
                                    className={
                                        'form-group' + (submitted && !password ? ' has-error' : '')
                                    }
                                >
                                    <label htmlFor="password">Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        name="password"
                                        value={password}
                                        onChange={this.handleChange}
                                    />
                                    {submitted && !password && (
                                        <div className="help-block">Password is required</div>
                                    )}
                                </div>
                                <div className="form-group text-center">
                                    By clicking below, you agree to the Customer Agreement and
                                    Privacy Policy
                                </div>
                                <div className="form-group text-center">
                                    <button className="btn btn-primary" disabled={signingUp}>
                                        Create My Account
                                    </button>
                                    {signingUp && (
                                        <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                    )}
                                </div>
                                <div className="form-group text-center">
                                    <span>Already registered?</span>
                                    <br />
                                    <a href="/login">Sign in to your account</a>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

SignupComponent.propTypes = {
    signUp: PropTypes.func.isRequired,
    federatedLogin: PropTypes.func.isRequired,
    signingUp: PropTypes.bool.isRequired,
    user: PropTypes.object,
};

function mapStateToProps(state) {
    const { signingUp, user } = state.signUp;
    return { signingUp, user };
}

const mapDispatchToProps = dispatch => bindActionCreators({ signUp, federatedLogin }, dispatch);

const hoc = connect(mapStateToProps, mapDispatchToProps)(SignupComponent);
export { hoc as SignupComponent };
